import createTopic from '#/utils/createTopic';

import { NotificationEntryType, NotificationPropsByType } from './types';

export type NotificationOptions = {
  [Type in NotificationEntryType]: {
    readonly kind: Type;
    readonly props: NotificationPropsByType[Type];
  };
};

/**
 * This topic is used to publish user notifications.
 * Examples of use include:
 *  • Display a toast;
 *  • Add a notification to the drawer.
 */
const topic =
  createTopic<NotificationOptions[NotificationEntryType]>('notification');

export function publishNotification<T extends NotificationEntryType>(
  options: NotificationOptions[T],
) {
  topic.publish(options);
}

export const notificationTopic = {
  subscribe: topic.subscribe,
  unsubscribe: topic.unsubscribe,
};
